import { render, staticRenderFns } from "./aiBannerAddPage.vue?vue&type=template&id=0badb8a4&scoped=true&"
import script from "./aiBannerAddPage.vue?vue&type=script&lang=js&"
export * from "./aiBannerAddPage.vue?vue&type=script&lang=js&"
import style0 from "./aiBannerAddPage.vue?vue&type=style&index=0&id=0badb8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badb8a4",
  null
  
)

export default component.exports